import {
  SET_CLEARING_SYSTEMS,
  UPDATE_CURRENT_CLAIM,
  RESET_CURRENT_CLAIM,
} from '../mutation-types'
import { GET_MARKETS } from '../action-types'

const claim = {
  namespaced: true,
  state: {
    CLAIM_TYPES: {
      SINGLE: 'Single Event',
      BULK: 'Bulk Upload',
    },
    currentClaim: {
      espSystem: null,
      espModel: null,
      market: null,
      security: null,
      incomeEvent: null,
      upload: null,
      reviewed: null,
      confirmed: null,
    },
    clearingSystems: null,
  },
  mutations: {
    [SET_CLEARING_SYSTEMS](state, payload) {
      state.clearingSystems = [...payload]
    },
    [UPDATE_CURRENT_CLAIM](state, payload) {
      if (typeof payload === 'string') state.currentClaim[payload] = null
      else {
        const { step, value } = payload
        state.currentClaim[step] = value
      }
    },
    [RESET_CURRENT_CLAIM]: (state) => {
      state.currentClaim = {
        espSystem: null,
        espModel: null,
        market: null,
        security: null,
        incomeEvent: null,
        upload: null,
        reviewed: null,
        confirmed: null,
      }
    },
  },
  actions: {
    async [GET_MARKETS]({ commit }) {
      commit(SET_CLEARING_SYSTEMS, await $.get(`${API_URL}/markets`))
    },
  },
  getters: {
    clearingSystem(state) {
      // TODO Returning 1st Clearing System
      return state.clearingSystems ? state.clearingSystems[0] : null
    },
    markets(state) {
      // TODO could take a clearingSystemId some day
      return state.clearingSystems ? state.clearingSystems[0].markets : null
    },
    isClaimInProgress: (state) => {
      return !!state.currentClaim.market
    },
    isCurrentClaimBulk: (state) => {
      if (state.currentClaim.espModel)
        return state.currentClaim.espModel.labelName === state.CLAIM_TYPES.BULK
      else return false
    },
    masterClaimId: (state) => {
      return state.currentClaim && state.currentClaim.upload
        ? state.currentClaim.upload.resourceId
        : 0
    },
    espSystemId: (state) => {
      return state.currentClaim && state.currentClaim.espSystem
        ? state.currentClaim.espSystem.espSystemId
        : 0
    },
    espModelId: (state) => {
      return state.currentClaim && state.currentClaim.espModel
        ? state.currentClaim.espModel.espModelId
        : 0
    },
    singleEventDetails: (state) => {
      return state.currentClaim &&
        typeof state.currentClaim.incomeEvent === 'object'
        ? state.currentClaim.incomeEvent
        : null
    },
  },
}

export default claim
